import { CrossIcon } from '@/src/assets/icons'
import { Box, Modal } from '@mui/material'
import React from 'react'

interface Props {
  children: React.ReactNode
  open: boolean
  classes?: string
  crossIconClasses?: string
  crossIcon?: boolean
  handleClose?: (data: any) => void
}

const CustomModal = ({
  children,
  open = false,
  classes = '',
  crossIcon = true,
  handleClose,
  crossIconClasses
}: Props) => {
  return (
    <Modal
      className="flex justify-center items-center"
      closeAfterTransition={false}
      open={open}
      onClose={!crossIcon ? handleClose : () => {}}
    >
      <Box className={`bg-white rounded-[1.25rem] flex flex-col relative outline-none ${classes}`}>
        {crossIcon && (
          <div className={`absolute top-4 right-4 z-10 ${crossIconClasses}`} onClick={handleClose}>
            <CrossIcon />
          </div>
        )}
        {children}
      </Box>
    </Modal>
  )
}

export default CustomModal
